export const ACTION_CODE = "CONTRACTS_ACTIONS";
